import { DeviceType } from 'app/agriculture/queries/devices/types/DeviceType';
import { useMemo } from 'react';
import { Device } from 'app/agriculture/queries/devices/types/Device';
import { useDevices } from 'app/agriculture/queries/devices/useDevices';

export function useDevicesByType(deviceType: DeviceType) {
    const devices = useDevices();

    const devicesByType = useMemo(() => {
        const deviceMap = new Map<DeviceType, Map<Device['id'], Device>>();
        for (const [id, device] of devices) {
            const typeMap = deviceMap.get(device.deviceType) ?? new Map<Device['id'], Device>();
            typeMap.set(id, device);
            deviceMap.set(device.deviceType, typeMap);
        }
        return deviceMap;
    }, [devices]);

    return useMemo(() => {
        const devices = devicesByType.get(deviceType);
        if (!devices) return new Map<Device['id'], Device>();
        return devices;
    }, [devicesByType, deviceType]);
}
